module.exports = __webpack_public_path__ + "static/invite_f-ebd1456371ee7b5e07e99acfb2f07aac.jpg";